import { css } from 'styled-components';
import { CFStyleThemes } from '../../theme';
import { MODAL_VEIL_Z_INDEX } from './tokens';
//
// Tokens
//
export const CFBaseModalVeilTokens = {
    TRANSITION_DURATION: 200,
};
//
// Helpers
//
export const CFBaseModalVeilHelpers = {
    backgroundColor: ({ alternateTheme, theme, visible, }) => {
        if (!visible) {
            return 'transparent';
        }
        if (alternateTheme) {
            return theme
                ? theme.COLOR.MODAL_VEIL_ALTERNATE
                : CFStyleThemes.DEFAULT.COLOR.MODAL_VEIL_ALTERNATE;
        }
        return theme
            ? theme.COLOR.MODAL_VEIL
            : CFStyleThemes.DEFAULT.COLOR.MODAL_VEIL;
    },
    rootCSSTransitions: ({ transitionState }) => {
        switch (transitionState) {
            case 'entering':
                return css `
          display: flex;
          opacity: 0;
        `;
            case 'entered':
                return css `
          opacity: 1;
        `;
            case 'exiting':
                return css `
          opacity: 0;
        `;
            case 'exited':
                return css `
          display: none;
          opacity: 0;
        `;
        }
    },
};
//
// Element Styles
//
export const CFBaseModalVeilStyles = {
    Hitspace: css `
    width: 100%;
    height: 100%;
    background-color: transparent;
    border: 0;
  `,
    Root: css `
    display: flex;
    position: absolute;
    z-index: ${MODAL_VEIL_Z_INDEX};
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    border: 0;
    background-color: ${CFBaseModalVeilHelpers.backgroundColor};
  `,
    RootWithCSSTransition: css `
    transition-duration: ${CFBaseModalVeilTokens.TRANSITION_DURATION}ms;
    transition-timing-function: ease-in-out;
    ${CFBaseModalVeilHelpers.rootCSSTransitions}
  `,
};
